<template>
  <div class="content">
    <div class="d-flex align-center h-100">
      <v-card class="mx-auto pa-10" elevation="8" width="400" max-width="448" rounded="lg">
        <v-card-title>
          <v-img class="mx-auto" max-width="228" src="@/assets/images/logo-wide.jpg" />
          <div class="text-center text-h5 py-5">Restablecer Contraseña</div>
        </v-card-title>
        <v-card-text>
          <div class="my-5" v-if="!notification.send">
            <div class="text-subtitle-1 text-medium-emphasis">Número de documento</div>
            <v-text-field v-model="form.document" density="compact" placeholder="Número de documento" prepend-inner-icon="mdi-email-outline" variant="outlined" 
            onkeypress="return event.charCode>=48 && event.charCode<=57"
            :error-messages="v$.document.$errors.map(e => e.$message)"/>
            <v-btn 
            color="orange" 
            size="large" 
            variant="tonal" 
            block 
            text="Reestblecer" 
            :loading="notification.loading"
            @click="send()"/>
          </div>
          <div v-if="notification.send">
            <v-alert color="info" variant="tonal" title="Revisa tu correo" v-if="!notification.failed">
              <div class="text-medium-emphasis text-caption">
                Se ha enviado un correo electrónico con las indicaciones para reestablecer la contraseña al correo que tienes registrado en plataforma.
              </div>
            </v-alert>
            <v-alert color="error" variant="tonal" title="Upss" v-if="notification.failed">
              <div class="text-medium-emphasis text-caption">
                {{ message }}
              </div>
            </v-alert>
          </div>          
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<script setup>
  import axios from 'axios'
  import Params from "../models/params";
  import { ref, reactive, computed } from 'vue';
  import { useVuelidate } from '@vuelidate/core';
  import { required, numeric, helpers } from '@vuelidate/validators';

  const params = ref(new Params);
  const message = ref(null);

  const form = reactive({
    document: null
  });

  const rules = computed(() => {
    return{
      document: { 
        required: helpers.withMessage('Campo requerido.', required), 
        numeric: helpers.withMessage('Solo números.', numeric) 
      }
    }
  })

  const notification = reactive({
    loading: false,
    send: false,
    failed: false
  });

  const v$ = useVuelidate(rules, form);

  async function send(){
    if(!await v$.value.$validate()){
      return
    }
    try {
      notification.loading = true;
      const frm = new FormData;
      frm.append("action", "rememberpassword");
      frm.append("document", form.document);
      const result = await eject(frm);
      notification.loading = false;
      notification.send = true;
      if(!result.status){
        notification.failed = true;
        message.value = result.message;
      }
    } catch (err) {
      console.log(err.message);
      notification.send = true;
      notification.failed = true;
    }
  }

  function eject(f){
    return new Promise((resolve) => {
      axios.post(params.value.controller + 'beneficiario.php',f)
      .then(res => {
        resolve(res.data)
      })
      .catch(() => {
        resolve(null)
      })
    })
  }

</script>